/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import SvgIcon from "@material-ui/core/SvgIcon";


export const ReferralIcon = ({ stroke = '#666',
  fill = 'none' }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M16 13.5455V16.8182L12.5636 19.3545" stroke={stroke} stroke-miterlimit="10" />
      <path d="M16 16.8182L19.4364 19.3545" stroke={stroke} stroke-miterlimit="10" />
      <path d="M16 13.5455C17.8075 13.5455 19.2727 12.0802 19.2727 10.2727C19.2727 8.46525 17.8075 7 16 7C14.1925 7 12.7273 8.46525 12.7273 10.2727C12.7273 12.0802 14.1925 13.5455 16 13.5455Z" stroke={stroke} stroke-miterlimit="10" stroke-linecap="square" />
      <path d="M10.2727 25C12.0802 25 13.5455 23.5347 13.5455 21.7273C13.5455 19.9198 12.0802 18.4545 10.2727 18.4545C8.46525 18.4545 7 19.9198 7 21.7273C7 23.5347 8.46525 25 10.2727 25Z" stroke={stroke} stroke-miterlimit="10" stroke-linecap="square" />
      <path d="M21.7273 25C23.5348 25 25 23.5347 25 21.7273C25 19.9198 23.5348 18.4545 21.7273 18.4545C19.9198 18.4545 18.4546 19.9198 18.4546 21.7273C18.4546 23.5347 19.9198 25 21.7273 25Z" stroke={stroke} stroke-miterlimit="10" stroke-linecap="square" />
    </svg>
  )
export const BackArrow = ({
  stroke = '#333333',
  fill = 'none'
}) => (
  <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 5.5H0.5" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.5 0.5L0.5 5.5L5.5 10.5" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

)
export const ReportIcon = ({
  stroke = '#666',
  fill = 'none'
}) => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M10.834 22.5003V11.667" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M15 22.4997V15.833" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M19.166 22.5003V11.667" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M23.334 22.4997V15.833" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M6.66602 22.5V7.5" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );


export const CloseIcon = ({
  stroke = "black",
  fill = "none",
  width = "24",
  height = "24"
}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5 5.5L5.5 19.5" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M19.5 19.5L5.5 5.5" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );


export const EmbedCodeIcon = ({ fill = "none",
  stroke = "#333333" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 3.5L7.5 16.5" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.5 6.5L2.5 9.5L5.5 12.5" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
      <path d="M14.5 6.5L17.5 9.5L14.5 12.5" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )





export const CopyIcon = ({ fill = "none",
  stroke = "#333333" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.2497 7.91669H9.58301V16.25H16.2497V7.91669Z" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7.08333 14.5833H3.75V3.75H12.9167V5.41667" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )

export const CopiedIcon = ({ fill = "none",
  stroke = "#333333" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 10.7L7.64286 13.5L15.5 6.5" stroke="#66D184" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square" />
    </svg>

  )


export const CopyIconPreview = ({ fill = "none",
  stroke = "#333333" }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.1003 9.23349C12.4003 10.5335 12.4003 12.6335 11.1003 13.9335L9.23359 15.8335C7.93359 17.1335 5.83359 17.1335 4.53359 15.8335C3.23359 14.5335 3.23359 12.4335 4.53359 11.1335L6.20026 9.53349" stroke={stroke} stroke-miterlimit="10" stroke-linecap="square" />
      <path d="M9.23379 11.1C7.93379 9.79996 7.93379 7.69996 9.23379 6.39996L11.1005 4.49996C12.4005 3.19996 14.5338 3.19996 15.8338 4.49996C17.1338 5.79996 17.1338 7.89996 15.8338 9.19996L14.1671 10.8333" stroke={stroke} stroke-miterlimit="10" stroke-linecap="square" />
    </svg>
  )


export const InsetLinkIcon = ({
  fill = "none",
  stroke = "#333333"
}) => (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_7352_45196)">
        <path d="M10.8987 22.3277C9.77396 21.0396 9.90672 19.0783 11.1948 17.9536L14.2078 15.3227L12.9581 13.8915L9.94508 16.5224C7.86611 18.3378 7.65216 21.4984 9.46751 23.5774C11.2829 25.6563 14.4435 25.8703 16.5224 24.0549L19.5354 21.424L18.2857 19.9928L15.2727 22.6238C13.9847 23.7485 12.0234 23.6157 10.8987 22.3277ZM14.6447 20.3842L20.6707 15.1223L19.3553 13.6158L13.3293 18.8777L14.6447 20.3842ZM17.4776 9.94509L14.4646 12.576L15.7143 14.0072L18.7273 11.3763C20.0153 10.2515 21.9766 10.3843 23.1013 11.6724C24.226 12.9604 24.0933 14.9217 22.8052 16.0464L19.7922 18.6773L21.0419 20.1085L24.0549 17.4776C26.1339 15.6622 26.3478 12.5016 24.5325 10.4227C22.7171 8.34369 19.5565 8.12974 17.4776 9.94509Z" fill={stroke} />
      </g>
      <defs>
        <clipPath id="clip0_7352_45196">
          <rect width="24" height="24" fill="white" transform="translate(0.0682373 15.8539) rotate(-41.1274)" />
        </clipPath>
      </defs>
    </svg>

  )


export const VerticalIcons = ({
  fill = "none",
  stroke = "#333333"
}) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" transform="translate(0 24) rotate(-90)" fill="white" />
      <path d="M13.2498 12.4163C13.2498 11.4959 12.5036 10.7497 11.5832 10.7497C10.6627 10.7497 9.9165 11.4959 9.9165 12.4163C9.9165 13.3368 10.6627 14.083 11.5832 14.083C12.5036 14.083 13.2498 13.3368 13.2498 12.4163Z" fill={stroke} />
      <path d="M13.2498 6.16634C13.2498 5.24587 12.5036 4.49967 11.5832 4.49967C10.6627 4.49967 9.9165 5.24587 9.9165 6.16634C9.9165 7.08682 10.6627 7.83301 11.5832 7.83301C12.5036 7.83301 13.2498 7.08682 13.2498 6.16634Z" fill={stroke} />
      <path d="M13.2498 18.6663C13.2498 17.7459 12.5036 16.9997 11.5832 16.9997C10.6627 16.9997 9.9165 17.7459 9.9165 18.6663C9.9165 19.5868 10.6627 20.333 11.5832 20.333C12.5036 20.333 13.2498 19.5868 13.2498 18.6663Z" fill={stroke} />
    </svg>

  )
export const UnAuthIconAppSwitcher = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.1111 7.11121H4.88889C4.39797 7.11121 4 7.50918 4 8.00009V11.5557C4 12.0466 4.39797 12.4445 4.88889 12.4445H11.1111C11.602 12.4445 12 12.0466 12 11.5557V8.00009C12 7.50918 11.602 7.11121 11.1111 7.11121Z"
      stroke="#999999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99997 10.6672C8.49089 10.6672 8.88886 10.2692 8.88886 9.77829C8.88886 9.28737 8.49089 8.8894 7.99997 8.8894C7.50905 8.8894 7.11108 9.28737 7.11108 9.77829C7.11108 10.2692 7.50905 10.6672 7.99997 10.6672Z"
      stroke="#999999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.222 6.99992V5.55558C10.2278 4.97213 10.0017 4.41026 9.59328 3.99354C9.18489 3.57681 8.6277 3.33934 8.04425 3.33336H7.99981C7.41636 3.32756 6.85449 3.55372 6.43776 3.96211C6.02103 4.3705 5.78357 4.92769 5.77759 5.51114V6.99992"
      stroke="#999999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DiamondIconAppSwitcher = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.33333 3.66663H11.6667L13 6.33329L8 12.3333L3 6.33329L4.33333 3.66663Z"
      stroke="#26BBED"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 6.33325H11"
      stroke="#26BBED"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HyMailAILarge = () => (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="50" fill="#26BBED" />
    <path
      d="M13.6777 28.691H13.357C12.8987 28.691 12.6696 28.4358 12.6696 27.9253V19.0071C12.6696 17.6258 12.0738 16.9352 10.8823 16.9352H9.23255C7.91885 16.9352 7.262 17.5958 7.262 18.917V27.9253C7.262 28.4358 7.03286 28.691 6.57459 28.691H6.25381C6.0094 28.691 5.82609 28.6009 5.70389 28.4208C5.61223 28.2406 5.56641 28.0754 5.56641 27.9253V11.2149C5.56641 11.0348 5.61223 10.8696 5.70389 10.7195C5.82609 10.5393 6.0094 10.4492 6.25381 10.4492H6.57459C7.03286 10.4492 7.262 10.7045 7.262 11.2149V15.5839C7.96467 15.2837 8.62152 15.1335 9.23255 15.1335H10.8823C11.9516 15.1335 12.807 15.4788 13.4486 16.1695C14.0902 16.8301 14.411 17.776 14.411 19.0071V27.9253C14.411 28.4358 14.1666 28.691 13.6777 28.691Z"
      fill="white"
    />
    <path
      d="M22.9688 27.7001C22.7244 28.4208 22.5105 29.0213 22.3272 29.5018C22.1439 29.9822 21.9758 30.3425 21.8231 30.5827C21.0288 31.8739 19.9595 32.5195 18.6152 32.5195H18.0195C17.8362 32.5195 17.6529 32.4595 17.4695 32.3394C17.2862 32.2493 17.1946 32.0541 17.1946 31.7538V31.4836C17.1946 31.2434 17.271 31.0482 17.4237 30.898C17.5765 30.7779 17.7751 30.7179 18.0195 30.7179H18.6152C19.3179 30.7179 19.8373 30.4476 20.1733 29.9071C20.5094 29.3666 20.7843 28.7811 20.9982 28.1505C20.3872 26.4389 19.7151 24.5472 18.9818 22.4753C18.2486 20.4034 17.5459 18.3765 16.8738 16.3947C16.8127 16.2446 16.8127 16.0494 16.8738 15.8092C16.9655 15.5689 17.164 15.4488 17.4695 15.4488H17.8362C18.1111 15.4488 18.325 15.5839 18.4777 15.8542C18.5388 15.9743 18.5694 16.0344 18.5694 16.0344L21.8231 25.5831L23.9311 19.4125L25.0768 16.0344C25.2295 15.644 25.4892 15.4488 25.8558 15.4488H26.1766C26.5127 15.4488 26.7113 15.5839 26.7724 15.8542C26.8335 16.0944 26.8488 16.2896 26.8182 16.4397L22.9688 27.7001Z"
      fill="white"
    />
    <path
      d="M30.2488 28.691H29.928C29.6836 28.691 29.5003 28.6009 29.3781 28.4208C29.2864 28.2406 29.2406 28.0754 29.2406 27.9253V11.2149C29.2406 11.0348 29.2864 10.8696 29.3781 10.7195C29.5003 10.5393 29.6836 10.4492 29.928 10.4492H30.2488C30.7376 10.4492 30.982 10.7045 30.982 11.2149V27.9253C30.982 28.4358 30.7376 28.691 30.2488 28.691Z"
      fill="white"
    />
    <path
      d="M39.8853 27.7001C39.6409 28.4208 39.427 29.0213 39.2437 29.5018C39.0604 29.9822 38.8924 30.3425 38.7396 30.5827C37.9453 31.8739 36.876 32.5195 35.5317 32.5195H34.936C34.7527 32.5195 34.5694 32.4595 34.3861 32.3394C34.2028 32.2493 34.1111 32.0541 34.1111 31.7538V31.4836C34.1111 31.2434 34.1875 31.0482 34.3402 30.898C34.493 30.7779 34.6916 30.7179 34.936 30.7179H35.5317C36.2344 30.7179 36.7538 30.4476 37.0898 29.9071C37.4259 29.3666 37.7009 28.7811 37.9147 28.1505C37.3037 26.4389 36.6316 24.5472 35.8984 22.4753C35.1651 20.4034 34.4624 18.3765 33.7903 16.3947C33.7292 16.2446 33.7292 16.0494 33.7903 15.8092C33.882 15.5689 34.0806 15.4488 34.3861 15.4488H34.7527C35.0276 15.4488 35.2415 15.5839 35.3943 15.8542C35.4554 15.9743 35.4859 16.0344 35.4859 16.0344L38.7396 25.5831L40.8476 19.4125L41.9933 16.0344C42.1461 15.644 42.4058 15.4488 42.7724 15.4488H43.0931C43.4292 15.4488 43.6278 15.5839 43.6889 15.8542C43.75 16.0944 43.7653 16.2896 43.7347 16.4397L39.8853 27.7001Z"
      fill="white"
    />
    <path
      d="M34.7773 41.5039C34.6875 41.5039 34.6201 41.459 34.5752 41.3691C34.5303 41.2643 34.5078 41.167 34.5078 41.0771V39.8418C34.5078 39.7519 34.5303 39.6621 34.5752 39.5723C34.6201 39.4674 34.6875 39.415 34.7773 39.415H35.2266C35.3164 39.415 35.3838 39.4674 35.4287 39.5723C35.4736 39.6621 35.4961 39.7519 35.4961 39.8418V41.0771C35.4961 41.167 35.4736 41.2643 35.4287 41.3691C35.3838 41.459 35.3164 41.5039 35.2266 41.5039H34.7773Z"
      fill="white"
    />
    <path
      d="M41.3647 41.5039C41.2605 41.5039 41.1824 41.4674 41.1303 41.3945C41.0782 41.3216 41.0418 41.2591 41.0209 41.207L40.5834 39.8789H38.5209L38.0522 41.2383C38.0314 41.3112 37.9897 41.3737 37.9272 41.4258C37.8647 41.4778 37.7918 41.5039 37.7085 41.5039H37.5991C37.4637 41.5039 37.3699 41.4518 37.3178 41.3476C37.2657 41.2435 37.2553 41.1497 37.2866 41.0664L39.0991 35.4727C39.1199 35.431 39.1512 35.3737 39.1928 35.3008C39.2449 35.2279 39.3282 35.1914 39.4428 35.1914H39.6459C39.823 35.1914 39.9428 35.2799 40.0053 35.457L41.8178 41.0664C41.8491 41.1497 41.8387 41.2435 41.7866 41.3476C41.7345 41.4518 41.6407 41.5039 41.5053 41.5039H41.3647ZM39.5366 36.6133C39.4845 36.8008 39.422 37.0091 39.3491 37.2383C39.2866 37.4674 39.2189 37.6914 39.1459 37.9101C39.0834 38.1289 39.0209 38.3372 38.9584 38.5351C38.8959 38.7331 38.8439 38.8997 38.8022 39.0351H40.3022L39.5366 36.6133Z"
      fill="white"
    />
    <path
      d="M43.1664 41.5039C43.0519 41.5039 42.9685 41.4622 42.9164 41.3789C42.8748 41.2956 42.8539 41.2174 42.8539 41.1445V35.5508C42.8539 35.4674 42.8748 35.3893 42.9164 35.3164C42.9685 35.2331 43.0519 35.1914 43.1664 35.1914H43.2914C43.5102 35.1914 43.6196 35.3112 43.6196 35.5508V41.1445C43.6196 41.3841 43.5102 41.5039 43.2914 41.5039H43.1664Z"
      fill="white"
    />
  </svg>
);

export const EditIcon = ({ stroke = "#333333", fill = "none" }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7656 5.59595L14.9602 8.79054" stroke={stroke} strokeMiterlimit="10" />
    <path
      d="M7.72218 16.0281L3.88867 16.667L4.52759 12.8335L13.098 4.26305C13.3377 4.02349 13.6626 3.88892 14.0015 3.88892C14.3403 3.88892 14.6653 4.02349 14.9049 4.26305L16.2926 5.65078C16.5322 5.89041 16.6668 6.21537 16.6668 6.55421C16.6668 6.89304 16.5322 7.21801 16.2926 7.45764L7.72218 16.0281Z"
      stroke={stroke}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const ScheduleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.875 8.625H22.125" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22.125 8.62501V5.92501C22.125 5.56697 21.9828 5.22359 21.7296 4.97042C21.4764 4.71724 21.133 4.57501 20.775 4.57501H3.225C2.86696 4.57501 2.52358 4.71724 2.27041 4.97042C2.01723 5.22359 1.875 5.56697 1.875 5.92501V20.775C1.875 21.1331 2.01723 21.4764 2.27041 21.7296C2.52358 21.9828 2.86696 22.125 3.225 22.125H9.975"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.27539 1.875V4.575" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.7246 1.875V4.575" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16.7252 22.125C19.7075 22.125 22.1252 19.7073 22.1252 16.725C22.1252 13.7427 19.7075 11.325 16.7252 11.325C13.7429 11.325 11.3252 13.7427 11.3252 16.725C11.3252 19.7073 13.7429 22.125 16.7252 22.125Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7246 14.025V16.725H19.4246"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShareIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.3125 8.5625L15.4375 1.6875V5.8125C11.098 5.8125 5.8125 8.36175 5.8125 15.4375C7.95613 11.9684 12 11.3125 15.4375 11.3125V15.4375L22.3125 8.5625Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.3125 15.4375V20.9375C22.3125 21.6965 21.6965 22.3125 20.9375 22.3125H3.0625C2.3035 22.3125 1.6875 21.6965 1.6875 20.9375V5.8125C1.6875 5.0535 2.3035 4.4375 3.0625 4.4375H5.8125"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StatisticsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 10.5L9.5 3.5L15.5 9.5L22.5 2.5"
      stroke="#212121"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M3.5 22.5V19.5" stroke="#212121" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M9.5 12.5V22.5" stroke="#212121" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M15.5 22.5V19.5" stroke="#212121" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M21.5 12.5V22.5" stroke="#212121" strokeMiterlimit="10" strokeLinecap="square" />
  </svg>
);

export const SlidesPreviewIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.87267 13.683C1.6301 13.3362 1.5 12.9232 1.5 12.5C1.5 12.0768 1.6301 11.6638 1.87267 11.317C3.44567 9.09 7.31867 4.5 12.4997 4.5C17.6807 4.5 21.5537 9.09 23.1267 11.317C23.3692 11.6638 23.4993 12.0768 23.4993 12.5C23.4993 12.9232 23.3692 13.3362 23.1267 13.683C21.5537 15.91 17.6807 20.5 12.4997 20.5C7.31867 20.5 3.44567 15.91 1.87267 13.683Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 16.5C14.7091 16.5 16.5 14.7091 16.5 12.5C16.5 10.2909 14.7091 8.5 12.5 8.5C10.2909 8.5 8.5 10.2909 8.5 12.5C8.5 14.7091 10.2909 16.5 12.5 16.5Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);